import React, {useState} from 'react';
import styles from '../../styles/RadioButtonBlue.module.scss';

const RadioButtonFour = ({
  firstText,
  secondText,
  thirdText,
  fourthText,
  setCheckValue,
  onchange
}) => {
  const [inputChecked, setInputChecked] = useState({
    radio1: true,

    radio2: false,
    radio3: false,
    radio4: false,
  });

  const handleRadioChange = checked => {
    setCheckValue(checked);
    setInputChecked(prev => ({
      ...prev,
      radio1: false,

      radio2: false,
      radio3: false,
      radio4: false,
      [checked]: true,
    }));
  };

  return (
    <div className={styles.radioButtons_}>
      <div className={styles.radioButton_}>
        <div
          className={styles.myCheckbox}
          onClick={() => {handleRadioChange('radio1'); onchange(firstText.toLowerCase())}}>
          <div
            className={
              inputChecked.radio1 ? styles.checked : styles.uncheck
            }></div>
        </div>

        <p>{firstText}</p>
      </div>
      <div className={styles.radioButton_}>
        <div
          className={styles.myCheckbox}
          onClick={() => {handleRadioChange('radio2'); onchange(secondText.toLowerCase())}}>
          <div
            className={
              inputChecked.radio2 ? styles.checked : styles.uncheck
            }></div>
        </div>
        <p>{secondText}</p>
      </div>
      <div className={styles.radioButton_}>
        <div
          className={styles.myCheckbox}
          onClick={() => {handleRadioChange('radio3'); onchange(thirdText.toLowerCase())}}>
          <div
            className={
              inputChecked.radio3 ? styles.checked : styles.uncheck
            }></div>
        </div>
        <p>{thirdText}</p>
      </div>
      <div className={styles.radioButton_}>
        <div
          className={styles.myCheckbox}
          onClick={() => {handleRadioChange('radio4'); onchange(fourthText.toLowerCase())}}>
          <div
            className={
              inputChecked.radio4 ? styles.checked : styles.uncheck
            }></div>
        </div>
        <p>{fourthText}</p>
      </div>
    </div>
  );
};

export default RadioButtonFour;
